<div
	[ngSwitch]="cameraLayoutOptionsContainer.options.cameraLayoutType"
	*ngIf="cameraLayoutOptionsContainer.options.screens"
	style="height: 100%"
>
	<ng-container
		*ngIf="
			cameraLayoutOptionsContainer.options.cameraViewMode === CameraViewMode.AllScreens ||
			cameraLayoutOptionsContainer.optionType === 'Playback'
		"
	>
		<sim-recorder-layout-bss *ngSwitchCase="CameraLayoutType.BSS" [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" />

		<sim-recorder-layout-bsss *ngSwitchCase="CameraLayoutType.BSSS" [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" />

		<sim-recorder-layout-pip
			*ngSwitchCase="CameraLayoutType.PictureInPicture"
			[isPipEditable]="isPipEditable"
			(pipLayoutOptionsChanged)="pipLayoutOptionsChanged.emit($event)"
			[cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer"
		/>

		<sim-recorder-layout-quad *ngSwitchCase="CameraLayoutType.Quad" [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" />

		<sim-recorder-layout-single *ngSwitchCase="CameraLayoutType.Single" [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" />

		<sim-recorder-layout-twin *ngSwitchCase="CameraLayoutType.TwinView" [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" />

		<sim-recorder-layout-tbt
			*ngSwitchCase="CameraLayoutType.ThreeByThree"
			[cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer"
		/>

		<sim-recorder-layout-twobthree
			*ngSwitchCase="CameraLayoutType.TwoByThree"
			[cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer"
		/>
	</ng-container>

	<ng-container
		*ngIf="
			!(
				cameraLayoutOptionsContainer.options.cameraViewMode === CameraViewMode.AllScreens ||
				cameraLayoutOptionsContainer.optionType === 'Playback'
			)
		"
	>
		<sim-recorder-layout-single
			[cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer"
			[screenIndexOverride]="cameraLayoutOptionsContainer.options.cameraViewMode | cameraViewModeToIndex"
		/>
	</ng-container>
</div>
